
// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE_URL}/api`; // Backend URL

// ---------------------------
// ✅ AUTHENTICATION
// ---------------------------

// Login
export const loginUser = async (username, password) => {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });

  if (!res.ok) {
    throw new Error("❌ Login failed");
  }

  return res.json();
};

// Logout (requires logId and token)
export const logoutUser = async (logId, token) => {
  const res = await fetch(`${API_URL}/auth/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // 🔑 JWT token
    },
    body: JSON.stringify({ logId }),
  });

  if (!res.ok) {
    throw new Error("❌ Logout failed");
  }

  return res.json();
};

// ---------------------------
// ✅ QUARTERS CRUD
// ---------------------------

// Get all quarters
export const getQuarters = async (token) => {
  const res = await fetch(`${API_URL}/quarters`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error("❌ Failed to fetch quarters");
  }

  return res.json();
};

// Add a new quarter
export const addQuarter = async (quarter, token) => {
  const res = await fetch(`${API_URL}/quarters`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(quarter),
  });

  if (!res.ok) {
    throw new Error("❌ Failed to add quarter");
  }

  return res.json();
};

// Update quarter
export const updateQuarter = async (id, quarter, token) => {
  const res = await fetch(`${API_URL}/quarters/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(quarter),
  });

  if (!res.ok) {
    throw new Error("❌ Failed to update quarter");
  }

  return res.json();
};

// Delete quarter
export const deleteQuarter = async (id, token) => {
  const res = await fetch(`${API_URL}/quarters/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error("❌ Failed to delete quarter");
  }

  return res.json();
};
